<template>
  <fin-data-loader :resolver="loadData" fullpage>
    <template #content>
      <h1 class="mb-6 mt-6"
          v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
          v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
        {{ title }}
      </h1>

      <div v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
           class="mb-1"
           style="line-height: 32px; width: 100%;">

        <fin-strategy-filter :archetypes="archetypes"
                             :asset-class-id="assetClassId"
                             :categories="strategiesCategories"
                             :filterable-items="strategies"
                             :simple-filter="isShareStrategy ? risksDropdown : etfAssetClassDropdown"
                             :simple-filter-items-name="isShareStrategy ? 'riskCategories' : 'assetClass'"
                             :simple-filter-label="isShareStrategy ? 'Risiko' : 'Assetklassen'"
                             :user-archetype="profileArchetype"
                             @itemsChanged="val => itemsChanged(val)"/>
      </div>

      <v-container class="d-flex flex-wrap" fluid
                   style="background-color: white"
                   v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
        <div v-if="false" style="text-align: right; width: 100%">
          <fin-dropdown :items="orderStrategiesDropdown"
                        label="Sortierung"
                        show-selection
                        single-select
                        v-model="sortSelection"/>
        </div>

        <!-- list of the strategies with title, name, teaser. Cards can be clicked -->
        <div v-if="mode === 'list'"
             class="d-flex flex-wrap justify-center">
          <fin-strategy-info-card v-for="(cardItem, index) of filteredStrategies"
                                  :key="index"
                                  :card-item="cardItem"
                                  :click-navigation="navigateTo(cardItem)"/>
        </div>

        <!-- list of the strategies with title, name and buttons. Card can not be clicked. Buttons instead -->
        <div class="d-flex flex-wrap justify-center " v-else-if="mode === 'chooseStrategy'">
          <fin-strategy-action-card v-for="(cardItem, index) of filteredStrategies"
                                    :key="index"
                                    :card-item="cardItem"
                                    :info-navigation="navigateTo(cardItem)"
                                    :selection-function="selectStrategy"/>
        </div>
      </v-container>
    </template>
  </fin-data-loader>
</template>

<script>
import {finPortfolioAPI, finStrategyAPI} from '@/js/finAPI'
import {listArchetypes} from "@/js/finQueries"
import {listEtfStrategyModels, listShareStrategyModels} from "@/js/finQueries"
import {API, graphqlOperation} from '@/plugins/finAmplifyModules'
import FinDropdown from "../../../common/Dropdown/index"
import FinDataLoader from "@/components/common/DataLoader/index"
import FinStrategyFilter from "@/components/common/filter/StrategyFilter"
import {mapGetters} from "vuex"
import FinStrategyInfoCard from "@/components/common/Strategy/InfoCard"
import FinStrategyActionCard from "@/components/common/Strategy/ActionCard"

export default {
  name: 'StrategyList',
  components: {FinStrategyActionCard, FinStrategyInfoCard, FinStrategyFilter, FinDataLoader, FinDropdown},
  props: {
    title: {
      type: String,
      default: 'Alle Strategiemodelle'
    },
    mode: {
      type: String,
      default: 'list'
    },
    goThenToPage: {
      type: String
    },
    portfolioId: {
      type: String
    },
    assetClassId: {
      type: String
    },
  },
  data() {
    return {
      strategies: null,
      filteredStrategies: null,
      strategiesCategories: null,
      archetypes: null,
      risksDropdown: [
        {title: 'geringe Risikoneigung', value: 'LOW'},
        {title: 'mittlere Risikoneigung', value: 'MEDIUM'},
        {title: 'hohe Risikoneigung', value: 'HIGH'}
      ],
      etfAssetClassDropdown: [
        {title: 'Aktien', value: 'SHARE_ETF'},
        {title: 'Unternehmensanleihen', value: 'CORPORATE_BONDS_ETF'},
        {title: 'Staatsanleihen', value: 'GOVERNMENT_BONDS_ETF'},
        {title: 'Rohstoffe', value: 'COMMODITIES_ETF'}
      ],
      isShareStrategy: false,
      isEtfStrategy: false,
      orderStrategiesDropdown: [{title: 'Beliebteste', emit: 'mostLikedStrategies'}],
      sortSelection: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['profileArchetype']),
  },
  methods: {
    navigateTo(cardItem) {
      if (cardItem && !cardItem.isLexikonCard) {
        let name = null

        if (this.isShareStrategy) {
          name = this.$route.params.portfolioId ? 'finStrategy_details_portfolio' : 'finStrategy_details'
        } else if (this.isEtfStrategy) {
          name = this.$route.params.portfolioId ? 'finStrategy_etfdetails_portfolio' : 'finStrategy_etfdetails'
        }

        return {
          name,
          params: {
            stratId: cardItem.id.toLowerCase(),
            mode: this.$route.params.mode,
            portfolioId: this.$route.params.portfolioId,
            assetClassID: this.$route.params.assetClassID,
            goThenToPage: this.$route.params.goThenToPage
          }
        }
      }
    },
    async selectStrategy(selectedStrategyId) {
      console.log("selectStrategy this.$route.params", this.$route.params)
      if (this.portfolioId) {
        try {
          // save this strategy into the portfolio for this asset class
          if (this.$route.params.assetClassID === 'SHARE') {
            await finPortfolioAPI.updateSharePortfolioStrategy(this.portfolioId, selectedStrategyId)
          } else if (this.$route.params.assetClassID === 'SHARE_ETF') {
            await finPortfolioAPI.updateShareETFPortfolioStrategy(this.portfolioId, selectedStrategyId)
          } else if (this.$route.params.assetClassID === 'CORPORATE_BONDS_ETF') {
            await finPortfolioAPI.updateCorporateBondsETFPortfolioStrategy(this.portfolioId, selectedStrategyId)
          } else if (this.$route.params.assetClassID === 'GOVERNMENT_BONDS_ETF') {
            await finPortfolioAPI.updateGovernmentBondsETFPortfolioStrategy(this.portfolioId, selectedStrategyId)
          } else if (this.$route.params.assetClassID === 'COMMODITIES_ETF') {
            await finPortfolioAPI.updateCommoditiesETFPortfolioStrategy(this.portfolioId, selectedStrategyId)
          }
          console.log("async saved the strategy " + selectedStrategyId + " to the portfolio " + this.portfolioId + " for the assetclass " + this.$route.params.assetClassID)
          this.$toasted.global.finToast({
            message: 'Deine Strategie wurde erfolgreich geändert.',
            type: 'success',
          })
        } catch (e) {
          console.error("selectStrategy: an error occured", e)
          this.$toasted.global.finToast({
            message: 'Deine Strategie konnte nicht erfolgreich geändert werden.',
            type: 'error'
          })
        }
      } /* else ev. show dialog to select portfolio */

      // bring user back to calling page (portfoliodetails for portfolio with portfolioId and calling tab)
      const goTo = {
        name: this.$route.params.goThenToPage,
        params: {
          id: this.$route.params.goThenToPage === 'portfolioDetail' ? this.portfolioId : '',
          tab: this.$route.params.assetClassID
        }
      }
      await this.$router.push(goTo)
    },
    async loadData() {
      this.isShareStrategy = this.$route.path.includes('/list/shares')
      this.isEtfStrategy = this.$route.path.includes('/list/etfs')

      // load the strategies
      if (this.isShareStrategy) {
        this.strategies = (await API.graphql(graphqlOperation(listShareStrategyModels))).data.listShareStrategyModels.items

        this.strategiesCategories = (await finStrategyAPI.searchSortedShareStrategyCategories()).map(cat => ({
          ...cat,
          color: this.getStrategyCategoryColor(cat.id)
        }))
      } else if (this.isEtfStrategy) {
        const allStrategies = (await API.graphql(graphqlOperation(listEtfStrategyModels))).data.listEtfStrategyModels.items

        let shareETF = allStrategies.filter(s => s.assetClass === 'SHARE_ETF')
        shareETF = this.nestedSort('category.id', shareETF)
        let commETF = allStrategies.filter(s => s.assetClass === 'COMMODITIES_ETF')
        commETF = this.nestedSort('category.id', commETF)
        let govBondsETF = allStrategies.filter(s => s.assetClass === 'GOVERNMENT_BONDS_ETF')
        govBondsETF = this.nestedSort('category.id', govBondsETF)
        let corpBondsETF = allStrategies.filter(s => s.assetClass === 'CORPORATE_BONDS_ETF')
        corpBondsETF = this.nestedSort('category.id', corpBondsETF)

        this.strategies = [
          ...shareETF,
          ...commETF,
          ...govBondsETF,
          ...corpBondsETF,
        ]

        this.strategiesCategories = (await finStrategyAPI.searchSortedEtfStrategyCategories()).map(cat => ({
          ...cat,
          color: this.getStrategyCategoryColor(cat.id)
        }))
      }

      this.filteredStrategies = [...this.strategies]

      // load the archetypes
      let allArchetypes = (await API.graphql(graphqlOperation(listArchetypes))).data.listArchetypes.items //TODO load with vuex
      this.archetypes = allArchetypes.filter(a => a.id !== 'INDIVIDUAL')
    },
    getStrategyCategoryColor(strategyId) {
      return this.$finStrategyColors.find(sc => sc.type === strategyId)?.color || 'transparent'
    },
    itemsChanged(val) {
      this.filteredStrategies = val
    },
    nestedSort(prop, arr) {
      prop = prop.split('.')
      let len = prop.length

      arr.sort(function (a, b) {
        let i = 0
        while (i < len) {
          a = a[prop[i]]
          b = b[prop[i]]
          i++
        }

        if (a < b) {
          return -1
        } else if (a > b) {
          return 1
        } else {
          return 0
        }
      })

      return arr
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
